import { type Plugin } from 'chart.js';

export const LegendPaddingPlugin: Plugin = {
  id: 'legendPaddingPlugin',
  beforeInit: function (chart, args, options) {
    if (chart.legend) {
      const { padding = 25 } = options;
      const legend = chart.legend as any;
      // Get a reference to the original fit function
      const originalFit = legend.fit;

      // Override the fit function
      legend.fit = function fit() {
        // Call the original function and bind scope in order to use `this` correctly inside it
        originalFit.bind(legend)();
        this.height += padding;
      };
    }
  },
};
